import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import Money from "@/components/Money.vue";
let Receipt = class Receipt extends Vue {
    invoice;
    customer;
    company;
    billing;
    get currency() {
        return this.$settings.currency.text;
    }
    productPrice(item) {
        return (item.price || {}).retailPrice || 0;
    }
};
__decorate([
    Prop({ type: Object, required: true })
], Receipt.prototype, "invoice", void 0);
__decorate([
    Prop({ type: Object, required: true })
], Receipt.prototype, "customer", void 0);
__decorate([
    Prop({ type: Object, required: true })
], Receipt.prototype, "company", void 0);
__decorate([
    Prop({ type: Object, required: true })
], Receipt.prototype, "billing", void 0);
Receipt = __decorate([
    Component({
        components: { Money }
    })
], Receipt);
export default Receipt;
